import Header from "../Header";
import ResturantPageResult from "./ResturantPageResult";

function ResturantPage() {
  return (
    <>
      <Header color='bg-danger'/>
      <ResturantPageResult/>
    </>
  );
}
export default ResturantPage;
